// File Metadata:
// Filename: NewShipmentFormConfirm.js
// Version: 1.00
// Created: 2022-10-21 21:10:05
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import {
    Alert,
    Box,
    Button,
    ButtonGroup,
    Card,
    CardContent,
    CardHeader,
    ImageList,
    ImageListItem,
    LinearProgress
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAddNewShipmentlogMutation } from '../../api/shipmentlogsApiSlice'
import uploadToImageKit from '../../../functions/imagekit'

import { CONSTANT } from '../../../config/constants'

const NewShipmentFormConfirm = ({ prevStep, values }) => {
    const navigate = useNavigate()
    const [addNewShipmentlog, { isLoading, isSuccess, isError, error }] = useAddNewShipmentlogMutation()
    const [errMsg, setErrMsg] = useState('')
    const [type, setType] = useState(values.type)
    const [sscc, setSscc] = useState(values.sscc)
    const [tour, setTour] = useState(values.tour)
    const [img, setImg] = useState([])
    const [files, setFiles] = useState(values.img)
    const [attachmentsReady, setAttachmentsReady] = useState(false)
    const [progress, setProgress] = useState({})

    const canSave =
        [type, sscc, tour, img].every(Boolean) && !isLoading && img.length === files.length && attachmentsReady

    useEffect(() => {
        if (isSuccess) {
            setErrMsg('')
            setType('')
            setSscc('')
            setTour('')
            setImg([])
            setFiles([])
            setAttachmentsReady(false)
            navigate('/dash/shipments')
        }
    }, [isSuccess, navigate])

    const handleUploads = async (data) => {
        if (data.length > 0) {
            let newArr = []
            for (let i = 0; i < data.length; i++) {
                let item = {};
                item = await uploadToImageKit(data[i], (percent) => {
                    setProgress(prev => ({ ...prev, [data[i].name]: percent }));
                });
                newArr.push(item)
            }
            return newArr
        } else {
            throw new Error('no files found')
        }
    }

    const saveToDb = async data => {
        addNewShipmentlog({
            type,
            sscc,
            tour,
            img: data,
            note: 'placeholder'
        })
    }

    const back = e => {
        e.preventDefault()
        prevStep()
    }

    const save = async e => {
        e.preventDefault()

        let imgData = []

        // implement imagekit.io upload of all files
        try {
            imgData = await handleUploads(files)
            // Response from imagekit.io
            // imgData => {fileId: string, fileName: string, url: string}
            
            //console.log(imgData)
            
            const response = await saveToDb(imgData)
            console.log(response)
        } catch (err) {
            alert(err)
        }
    }

    return (
        <>
            <Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
                <CardHeader title='Confirm input' subheader='submit your new entry' />
                <CardContent>
                    {errMsg && <Alert severity='error'>{errMsg}</Alert>}
                    <Box sx={{ margin: 1 }}>
                        <ImageList sx={{ maxWidth: 340 }} cols={3}>
                            {files.map((item, i) => (
                                <ImageListItem cols={1} rows={1} key={i}>
                                    <img src={`${item.img}`} alt={item.name} />
                                    <LinearProgress
                                        variant='determinate'
                                        color='success'
                                        value={progress[item.name] || 0}
                                        sx={{ visibility: progress[item.name] > 0 ? 'visible' : 'hidden' }}
                                    />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </Box>
                    <ButtonGroup fullWidth variant='contained'>
                        <Button onClick={back}>Back</Button>
                        <Button onClick={save}>Save</Button>
                    </ButtonGroup>
                </CardContent>
            </Card>
            <div id='tmpImage'></div>
        </>
    )
}

export default NewShipmentFormConfirm
